var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-items-edit',{attrs:{"content-type":"trial-reports","content-type-singular":"trial-report","content-name":"Trial Reports","content-name-singular":"Trial Report"}})}
var staticRenderFns = []

export { render, staticRenderFns }